import { fork } from 'redux-saga/effects';

import approve from './approve';
import claim from './claim';
import getAirdropInfo from './getAirdropInfo';
import getIsKycApproved from './getIsKycApproved';
import getVestingSwapInfo from './getSwapInfo';
import getBuyInfo from './getBuyInfo';
import getTokenBalance from './getTokenBalance';
import saveKyc from './saveKyc';
import swap from './swap';
import buy from './buy';

export function* userSagas() {
  yield fork(approve);
  yield fork(claim);
  yield fork(getAirdropInfo);
  yield fork(getIsKycApproved);
  yield fork(getVestingSwapInfo);
  yield fork(getBuyInfo);
  yield fork(getTokenBalance);
  yield fork(saveKyc);
  yield fork(swap);
  yield fork(buy);
}
